import * as sentry from '@sentry/browser';
import apolloClient from 'services/apollo-client';
import useFetchSurfaceNodesFromCache from 'components/canvas/hooks/use-fetch-surface-nodes-from-cache';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import { isPlainObject } from 'lodash';

type Input = {
  id: string;
  cache?: any;
  surface?: string;
};

export function useFetchNodeFromCacheById(surface?: string) {
  const currentSurface = useCurrentSurface();

  const surfaceId = surface ?? currentSurface?.id;

  const fetchSurfaceNodesFromCache = useFetchSurfaceNodesFromCache(surfaceId);

  return function fetchNodeFromCacheById(input: Input | string) {
    try {
      if (isPlainObject(input)) {
        const {
          id,
          cache = apolloClient,
          surface = surfaceId,
        } = input as Input;

        return fetchSurfaceNodesFromCache({ surface, cache }).find(
          (node) => node.id === id,
        );
      }

      return fetchSurfaceNodesFromCache().find((node) => node.id === input);
    } catch (error) {
      console.error(error);
      sentry.captureException(error);
    }
  };
}

export default useFetchNodeFromCacheById;
